// src/components/Propuestas/DetallePropuesta.js
import React, { useState, useEffect } from 'react';
import { 
  Card, Button, Badge, Table, Row, Col, Spinner, Alert, 
  Tabs, Tab, Modal, Form, Dropdown 
} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  obtenerPropuesta,
  obtenerVersionesPropuesta,
  enviarPropuesta,
  getDataObtenerUno,
  procesarCambiosPropuesta,
  validarSincronizacionPropuesta,
  sincronizarPropuestaContable,
  autorizarPropuesta,
  reactivarPropuesta,
  subirArchivoPropuesta,
  agregarAdjuntoPropuesta,
  eliminarAdjuntoPropuesta,
  actualizarDatos,
  descargarPropuestaPdf,
  obtenerPlantillaUnica,
} from '../../api/common';

import { generarPDFPropuesta } from './PdfPropuesta';
import ModalEnvioEmail from './ModalEnvioEmail';
import TimelinePropuesta from './TimelinePropuesta';
import extraerNombreArchivo from './extraerNombreArchivoFirebase';
import ClienteModal from '../Clientes/ClienteModal';

const DetallePropuesta = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [propuesta, setPropuesta] = useState(null);

  console.log('Propuesta cargada:', propuesta);
  const [versiones, setVersiones] = useState([]);

  // constante para saber si el cliente esta sincronizado con el software contable 
  const [modalSyncCliente, setModalSyncCliente] = useState({ show: false, cliente: null });
  // Adjuntos
  const [subiendoAdj, setSubiendoAdj] = useState(false);
  console.log('Versiones:', versiones);
  const [versionSeleccionada, setVersionSeleccionada] = useState(null);
  const [activeTab, setActiveTab] = useState('detalle');
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  
  // Modal enviar por correo
  const [showModalEmail, setShowModalEmail] = useState(false);
  const [enviandoEmail, setEnviandoEmail] = useState(false);
  // Sync contable
  const [syncValidacion, setSyncValidacion] = useState(null);
  const [syncLoading, setSyncLoading] = useState(false);
  const [showDebugPayload, setShowDebugPayload] = useState(false);
  // Autorizar
  const [autorizando, setAutorizando] = useState(false);
  // Cambios
  const [procesandoCambios, setProcesandoCambios] = useState(false);
  // Observaciones expand
  const [obsExpanded, setObsExpanded] = useState(false);
  const OBS_LIMIT = 2000;
  // Reactivar
  const [mostrarReactivar, setMostrarReactivar] = useState(false);
  const [reactivarData, setReactivarData] = useState({ nueva_fecha_vigencia: '', email_destino: '' });
  const [reactivarLoading, setReactivarLoading] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, [id]);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      // Cargar propuesta
      const propRes = await getDataObtenerUno('Propuestas',{_id:id});
      console.log(propRes)
      if (propRes.status==200 && propRes.data.data) {
        setPropuesta(propRes.data.data);
      }

      //Cargar versiones
      const versRes = await obtenerVersionesPropuesta(id);

      console.log('versiones: ', versRes)
      if (versRes.status==200 && versRes.data.data) {
        setVersiones(versRes.data.data);
      }

    } catch (error) {
      console.error('Error al cargar datos:', error);
      setMensaje({ tipo: 'danger', texto: 'Error al cargar la propuesta' });
    } finally {
      setLoading(false);
    }
  };

  const handleEnviarPropuesta = async (email_destino) => {
    setEnviandoEmail(true);
    try {
      const response = await enviarPropuesta(id, { email_destino });
      console.log('Respuesta enviarPropuesta:', response);
      if (response.status === 200) {
        setMensaje({ tipo: 'success', texto: 'Propuesta enviada correctamente' });
        setShowModalEmail(false);
        cargarDatos();
      } else {
        setMensaje({ tipo: 'danger', texto: response.message || 'Error al enviar propuesta' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al enviar propuesta' });
    } finally {
      setEnviandoEmail(false);
    }
  };

  const handleProcesarCambios = async () => {
    setProcesandoCambios(true);
    try {
      const response = await procesarCambiosPropuesta(id);
      if (response.status === 200) {
        setMensaje({ tipo: 'success', texto: 'Cambios marcados como revisados' });
        cargarDatos();
      } else {
        setMensaje({ tipo: 'danger', texto: response.message || 'Error al procesar cambios' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al procesar cambios' });
    } finally {
      setProcesandoCambios(false);
    }
  };

  const handleAutorizar = async () => {
    setAutorizando(true);
    try {
      const response = await autorizarPropuesta(id);
      if (response.status === 200) {
        setMensaje({ tipo: 'success', texto: 'Propuesta autorizada correctamente. Ya puede ser enviada al cliente.' });
        cargarDatos();
      } else {
        setMensaje({ tipo: 'danger', texto: response.data?.message || 'Error al autorizar propuesta' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al autorizar propuesta' });
    } finally {
      setAutorizando(false);
    }
  };

  const handleValidarSync = async () => {
    setSyncLoading(true);
    try {
      const response = await validarSincronizacionPropuesta(id);

      if (response.status === 200) {
        setSyncValidacion(response.data);
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al validar sincronización' });
    } finally {
      setSyncLoading(false);
    }
  };

  const handleSincronizar = async () => {
    setSyncLoading(true);
    try {
      const response = await sincronizarPropuestaContable(id);
      if (response.status === 200) {
        setMensaje({ tipo: 'success', texto: 'Propuesta sincronizada correctamente' });
        setSyncValidacion(null);
        cargarDatos();
      } else {
        setMensaje({ tipo: 'danger', texto: response.data?.message || 'Error al sincronizar' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al sincronizar propuesta' });
    } finally {
      setSyncLoading(false);
    }
  };

  const handleReactivar = async () => {
    if (!reactivarData.nueva_fecha_vigencia || !reactivarData.email_destino) {
      setMensaje({ tipo: 'warning', texto: 'Debe proporcionar fecha de vigencia y email' });
      return;
    }
    setReactivarLoading(true);
    try {
      const response = await reactivarPropuesta(id, reactivarData);
      if (response.status === 200) {
        setMensaje({ tipo: 'success', texto: 'Propuesta reactivada correctamente' });
        setMostrarReactivar(false);
        cargarDatos();
      } else {
        setMensaje({ tipo: 'danger', texto: response.data?.message || 'Error al reactivar' });
      }
    } catch (error) {
      setMensaje({ tipo: 'danger', texto: 'Error al reactivar propuesta' });
    } finally {
      setReactivarLoading(false);
    }
  };

const handleGenerarPDF = async () => {

  // SE VA A UTILIZAR PDFPROPUESTA.JS DEL FRONT 
    try {
      const plantilla = await obtenerPlantillaUnica();
      const plantilladata = plantilla.data?.data;

      const resultado = await generarPDFPropuesta(propuesta, plantilladata);
      
    } catch (error) {
      console.log(error)
    }


  /*try {
    const response = await descargarPropuestaPdf(id);
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const filename = response.headers?.['content-disposition']
      ?.match(/filename="?([^"]+)"?/)?.[1] || `Propuesta_${id}.pdf`;
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setMensaje({ tipo: 'success', texto: 'PDF descargado correctamente' });
  } catch (error) {
    setMensaje({ tipo: 'danger', texto: 'Error al generar PDF' });
    console.error(error);
  }*/
};

  const handleVerVersion = (version) => {
    console.log('Ver versión:', version);
    setVersionSeleccionada(version);
    setActiveTab('detalle');
  };

  const handleVolverVersionActual = () => {
    setVersionSeleccionada(null);
  };

  const handleSaveCliente = async (formDataCliente) => {
    const clienteId = propuesta.cliente_id?._id;
    try {
     const clienteSync = await actualizarDatos ('Usuarios', formDataCliente, clienteId);

      // ahora actualiza la propuesta para tomar los nuevos datos del cliente
      const resultadoPropuesta = await actualizarDatos('Propuestas', {
        cliente_nit: clienteSync.data.data.identificacion,
        cliente_nombre: clienteSync.data.data.cliente_nombre,
        clienteIdContable: clienteSync.data.data.contabilidad?.id || null,
      },propuesta._id);

      console.log('Propuesta actualizada:', resultadoPropuesta);

      // Recargar lista de clientes para reflejar el nuevo estado de sync
      await cargarDatos();
      setModalSyncCliente({ show: false, cliente: null });
    } catch (err) {
      console.error('Error al actualizar cliente:', err);
    }
  };

  const getEstadoBadge = (estado) => {
    const estados = {
      borrador: { variant: 'secondary', icon: 'pencil', text: 'Borrador' },
      autorizada: { variant: 'info', icon: 'check2-circle', text: 'Autorizada' },
      enviada: { variant: 'info', icon: 'send', text: 'Enviada' },
      vista: { variant: 'primary', icon: 'eye', text: 'Vista' },
      aprobada: { variant: 'success', icon: 'check-circle', text: 'Aprobada' },
      rechazada: { variant: 'danger', icon: 'x-circle', text: 'Rechazada' },
      cambios_solicitados: { variant: 'warning', icon: 'pencil-square', text: 'Cambios Solicitados' },
      vencida: { variant: 'warning', icon: 'clock', text: 'Vencida' },
      facturada: { variant: 'dark', icon: 'receipt', text: 'Facturada' }
    };
    
    const est = estados[estado] || estados.borrador;
    
    return (
      <Badge bg={est.variant} className="fs-6">
        <i className={`bi bi-${est.icon} me-1`}></i>
        {est.text}
      </Badge>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Cargando propuesta...</p>
      </div>
    );
  }

  if (!propuesta) {
    return (
      <Alert variant="danger">
        <i className="bi bi-exclamation-triangle me-2"></i>
        Propuesta no encontrada
      </Alert>
    );
  }

  const dataActual = versionSeleccionada || propuesta;

  console.log('Propuesta actual:', dataActual);

  // ── Solicitudes de cambio del cliente ──────────────────────────────
  const solicitudesCambio = dataActual.solicitudes_cambio || [];
  const getSolicitudItem = (index) => solicitudesCambio.find(s => s.item_index === index);

  const SOLICITUD_CFG = {
    eliminar:           { bgPendiente: '#ffe0de', bgOtro: '#fff5f5', icon: 'bi-trash-fill',             colorHex: '#dc3545', label: 'Eliminar ítem' },
    reducir_cantidad:   { bgPendiente: '#fff3cc', bgOtro: '#fffde7', icon: 'bi-arrow-down-circle-fill', colorHex: '#e08000', label: 'Reducir cantidad' },
    solicitar_descuento:{ bgPendiente: '#cce5ff', bgOtro: '#e8f4ff', icon: 'bi-percent',               colorHex: '#0d6efd', label: 'Solicitar descuento' },
  };

  const getEstiloFilaSolicitud = (index) => {
    const s = getSolicitudItem(index);
    if (!s) return {};
    const cfg = SOLICITUD_CFG[s.tipo_cambio];
    if (!cfg) return {};
    return { backgroundColor: s.estado_solicitud === 'pendiente' ? cfg.bgPendiente : cfg.bgOtro };
  };

  const renderIconoSolicitud = (index) => {
    const s = getSolicitudItem(index);
    if (!s) return null;
    const cfg = SOLICITUD_CFG[s.tipo_cambio];
    if (!cfg) return null;
    const partes = [
      cfg.label,
      s.cantidad_sugerida ? `Nueva cant.: ${s.cantidad_sugerida}` : '',
      s.comentario_cliente ? `"${s.comentario_cliente}"` : '',
      s.estado_solicitud !== 'pendiente' ? `Estado: ${s.estado_solicitud}` : 'Pendiente de revisión',
    ].filter(Boolean);
    return (
      <i
        className={`bi ${cfg.icon} ms-1`}
        style={{ color: cfg.colorHex, cursor: 'help', fontSize: '0.8rem' }}
        title={partes.join(' | ')}
      />
    );
  };


  // ────────────────────────────────────────────────────────────────────

  return (
    <div className="container-fluid py-4">
      {mensaje.texto && (
        <Alert 
          variant={mensaje.tipo} 
          dismissible 
          onClose={() => setMensaje({ tipo: '', texto: '' })}
        >
          {mensaje.texto}
        </Alert>
      )}

      {versionSeleccionada && (
        <Alert variant="warning">
          <i className="bi bi-clock-history me-2"></i>
          Visualizando versión {versionSeleccionada.numero_version}
          <Button 
            variant="link" 
            size="sm" 
            onClick={handleVolverVersionActual}
            className="ms-3"
          >
            Volver a versión actual
          </Button>
        </Alert>
      )}

      {/* MODAL: Sincronizar cliente con software contable */}
      <ClienteModal
        show={modalSyncCliente.show}
        onHide={() => setModalSyncCliente({ show: false, cliente: null })}
        usuario={modalSyncCliente.cliente}
        onSave={handleSaveCliente}
      />
      {/* Alerta: pendiente de primera sincronización */}
      {!dataActual.sincronizada && dataActual.cliente_id?.contabilidad?.id && (
        <Alert variant="info" className="m-3 d-flex justify-content-between align-items-center">
          <span>
            <i className="bi bi-clock-history me-2"></i>
            Propuesta pendiente de sincronizar con el software contable. El consecutivo se asignará al completar la sincronización.
          </span>
        </Alert>
      )}

      {/* Alerta: sincronizada OK y última actualización exitosa */}
      {dataActual.sincronizada && dataActual.actualizacionSincronizacion && (
        <Alert variant="success" className="m-3 d-flex justify-content-between align-items-center">
          <span>
            <i className="bi bi-check-circle me-2"></i>
            Propuesta sincronizada correctamente con el software contable
            {dataActual.propuestaContable_numero && ` — N.º contable: ${dataActual.propuestaContable_numero}`}
          </span>
        </Alert>
      )}

      {/* Alerta: sincronizada pero última actualización falló */}
      {dataActual.sincronizada && !dataActual.actualizacionSincronizacion && (
        <Alert variant="warning" className="m-3 d-flex justify-content-between align-items-center">
          <span>
            <i className="bi bi-exclamation-triangle me-2"></i>
            La última actualización no se pudo sincronizar con el software contable. Guarde la propuesta de nuevo para reintentar.
          </span>
        </Alert>
      )}

      <Card className='w-100'>
          {/* BANNER: CLIENTE SIN SYNC colocar margen a todos los lados en alert*/} 
          {!dataActual.cliente_id?.contabilidad?.id && ( 
            <Alert variant="warning" className="m-3 d-flex justify-content-between align-items-center w-100">
              <span>
                <i className="bi bi-person-exclamation me-2"></i>
                El cliente seleccionado no está sincronizado con el software contable. La propuesta no se podrá sincronizar con el proveedor contable hasta que se sincronice el cliente.
              </span>
              <Button
                size="sm"
                variant="warning"
                onClick={() => setModalSyncCliente({ show: true, cliente: dataActual.cliente_id })}
              >
                <i className="bi bi-arrow-repeat me-1"></i>Sincronizar cliente
              </Button>
            </Alert>
          )}

        <Card.Header className="bg-primary text-white w-100">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
            <div>
              <h5 className="mb-1">
                <i className="bi bi-file-earmark-text me-2"></i>
                Propuesta {propuesta.consecutivo || <span className="fst-italic opacity-75 fs-6">Sin consecutivo</span>}
              </h5>
              <small>Versión {propuesta.numero_version}</small>
            </div>

            {/* ── Acciones: desktop (lg+) ─────────────────────────── */}
            <div className="d-none d-lg-flex flex-wrap gap-2">
              <Button variant="light" size="sm" onClick={() => navigate(`/propuestas/editar/${id}`)}>
                <i className="bi bi-pencil me-1"></i>Editar
              </Button>

              {propuesta.estado === 'borrador' && (
                <Button
                  variant="outline-warning"
                  size="sm"
                  onClick={handleAutorizar}
                  disabled={autorizando}
                >
                  {autorizando
                    ? <><Spinner animation="border" size="sm" className="me-1" />Autorizando...</>
                    : <><i className="bi bi-check2-circle me-1"></i>Autorizar</>
                  }
                </Button>
              )}

              {!propuesta.sincronizada && (
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={handleValidarSync}
                  disabled={syncLoading}
                  title="Validar y sincronizar con software contable"
                >
                  {syncLoading
                    ? <><Spinner animation="border" size="sm" className="me-1" />Validando...</>
                    : <><i className="bi bi-arrow-repeat me-1"></i>Sincronizar</>
                  }
                </Button>
              )}

              <Button
                variant={propuesta.estado === 'autorizada' ? 'success' : 'outline-light'}
                size="sm"
                onClick={() => setShowModalEmail(true)}
                disabled={propuesta.estado !== 'autorizada'}
                title={propuesta.estado !== 'autorizada' ? 'Autoriza la propuesta antes de enviarla' : 'Enviar al cliente'}
              >
                <i className="bi bi-send me-1"></i>Enviar al Cliente
              </Button>

              <Button variant="light" size="sm" onClick={handleGenerarPDF}>
                <i className="bi bi-file-pdf me-1"></i>Exportar PDF
              </Button>

              <Button variant="outline-light" size="sm" onClick={() => navigate('/propuestas')}>
                <i className="bi bi-arrow-left me-1"></i>Volver
              </Button>
            </div>

            {/* ── Acciones: móvil (<lg) — dropdown ──────────────── */}
            <div className="d-flex d-lg-none gap-2 align-self-end">
              <Button variant="outline-light" size="sm" onClick={() => navigate('/propuestas')}>
                <i className="bi bi-arrow-left"></i>
              </Button>
              <Dropdown align="end">
                <Dropdown.Toggle variant="light" size="sm" id="acciones-mobile">
                  <i className="bi bi-three-dots-vertical me-1"></i>Acciones
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate(`/propuestas/editar/${id}`)}>
                    <i className="bi bi-pencil me-2"></i>Editar
                  </Dropdown.Item>

                  {propuesta.estado === 'borrador' && (
                    <Dropdown.Item onClick={handleAutorizar} disabled={autorizando}>
                      <i className="bi bi-check2-circle me-2"></i>
                      {autorizando ? 'Autorizando…' : 'Autorizar'}
                    </Dropdown.Item>
                  )}

                  {!propuesta.sincronizada && (
                    <Dropdown.Item onClick={handleValidarSync} disabled={syncLoading}>
                      <i className="bi bi-arrow-repeat me-2"></i>
                      {syncLoading ? 'Validando…' : 'Sincronizar'}
                    </Dropdown.Item>
                  )}

                  <Dropdown.Item
                    onClick={() => setShowModalEmail(true)}
                    disabled={propuesta.estado !== 'autorizada'}
                  >
                    <i className="bi bi-send me-2"></i>Enviar al Cliente
                    {propuesta.estado !== 'autorizada' && (
                      <small className="text-muted ms-1">(autorizar primero)</small>
                    )}
                  </Dropdown.Item>

                  <Dropdown.Item onClick={handleGenerarPDF}>
                    <i className="bi bi-file-pdf me-2"></i>Exportar PDF
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Card.Header>

        <Card.Body className='w-100'>

          <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-3">
            {/* TAB: DETALLE */}
            <Tab eventKey="detalle" title={<><i className="bi bi-info-circle me-2"></i>Detalle</>}>
              {/* INFORMACIÓN GENERAL */}
              <Row className="mb-4">
                <Col md={6}>
                  <Card className="border-0 shadow-sm w-100">
                    <Card.Body className='w-100'>
                      <h6 className="border-bottom pb-2 mb-3">Información del Cliente</h6>
                      <table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td className="text-muted" width="40%">Nombre:</td>
                            <td><strong>{dataActual.cliente_nombre}</strong></td>
                          </tr>
                          <tr>
                            <td className="text-muted">NIT:</td>
                            <td>{dataActual.cliente_nit}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Email:</td>
                            <td>{dataActual.cliente_email}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Teléfono:</td>
                            <td>{dataActual.cliente_telefono || 'N/A'}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Dirección:</td>
                            <td>{dataActual.cliente_direccion || 'N/A'}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Ciudad:</td>
                            <td>{dataActual.cliente_ciudad || 'N/A'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card className="border-0 shadow-sm w-100">
                    <Card.Body className='w-100'>
                      <h6 className="border-bottom pb-2 mb-3">Información de la Propuesta</h6>
                      <table className="table table-sm table-borderless">
                        <tbody>
                          <tr>
                            <td className="text-muted" width="40%">Estado:</td>
                            <td>{getEstadoBadge(dataActual.estado)}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Fecha:</td>
                            <td>{moment.utc(dataActual.fecha_propuesta).format('DD/MM/YYYY')}</td>
                          </tr>
                          <tr>
                            <td className="text-muted">Vigencia hasta:</td>
                            <td>
                              <span className={moment.utc(dataActual.fecha_vigencia).isBefore(moment()) ? 'text-danger fw-bold' : ''}>
                                {moment.utc(dataActual.fecha_vigencia).format('DD/MM/YYYY')}
                              </span>
                            </td>
                          </tr>
                          {dataActual.fecha_envio && (
                            <tr>
                              <td className="text-muted">Enviada el:</td>
                              <td>{moment.utc(dataActual.fecha_envio).format('DD/MM/YYYY HH:mm')}</td>
                            </tr>
                          )}
                          {dataActual.fecha_aprobacion && (
                            <tr>
                              <td className="text-muted">Aprobada el:</td>
                              <td>{moment.utc(dataActual.fecha_aprobacion).format('DD/MM/YYYY HH:mm')}</td>
                            </tr>
                          )}
                          {dataActual.aprobada_por && (
                            <tr>
                              <td className="text-muted">Aprobada por:</td>
                              <td>{dataActual.aprobada_por}</td>
                            </tr>
                          )}
                          {dataActual.motivo_rechazo && (
                            <tr>
                              <td className="text-muted">Motivo rechazo:</td>
                              <td className="text-danger">{dataActual.motivo_rechazo}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* ÍTEMS */}
              <h6 className="border-bottom pb-2 mb-3">Ítems de la Propuesta</h6>
              <div className="table-responsive">
                <Table bordered hover>
                  <thead className="table-light">
                    <tr>
                      <th width="5%">#</th>
                      <th width="10%">Código</th>
                      <th width="20%">Nombre</th>
                      <th width="30%">Descripción</th>
                      <th width="8%" className="text-center">Cant.</th>
                      <th width="12%" className="text-end">V. Unitario</th>
                      <th width="7%" className="text-center">IVA</th>
                      <th width="7%" className="text-center">Dto. %</th>
                      <th width="13%" className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataActual.items?.map((item, index) => (
                      <tr key={index} style={getEstiloFilaSolicitud(index)}>
                        <td>{index + 1}{renderIconoSolicitud(index)}</td>
                        <td>{item.codigo}</td>
                        <td><strong>{item.nombre}</strong></td>
                        <td><small>{item.descripcion}</small></td>
                        <td className="text-center">{item.cantidad}</td>
                        <td className="text-end">
                          ${item.valor_unitario.toLocaleString('es-CO')}
                        </td>
                        <td className="text-center">{item.porcentaje_iva}%</td>
                        <td className="text-center">{item.taxDescuento > 0 ? `${item.taxDescuento}%` : '-'}</td>
                        <td className="text-end fw-bold">
                          ${item.total.toLocaleString('es-CO')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="8" className="text-end fw-bold">Total Bruto:</td>
                      <td className="text-end fw-bold">
                        ${dataActual.total_bruto?.toLocaleString('es-CO')}
                      </td>
                    </tr>
                    {(dataActual.total_bruto - dataActual.subtotal) > 0 && (
                      <tr className="table-warning">
                        <td colSpan="8" className="text-end fw-bold">Descuento:</td>
                        <td className="text-end fw-bold">
                          -${(dataActual.total_bruto - dataActual.subtotal)?.toLocaleString('es-CO')}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td colSpan="8" className="text-end fw-bold">Subtotal:</td>
                      <td className="text-end fw-bold">
                        ${dataActual.subtotal?.toLocaleString('es-CO')}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="8" className="text-end fw-bold">IVA:</td>
                      <td className="text-end fw-bold">
                        ${dataActual.total_iva?.toLocaleString('es-CO')}
                      </td>
                    </tr>
                    <tr className="table-primary">
                      <td colSpan="8" className="text-end fw-bold fs-5">TOTAL A PAGAR:</td>
                      <td className="text-end fw-bold fs-5">
                        ${dataActual.total_pagar?.toLocaleString('es-CO')}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>

              {/* CONDICIONES COMERCIALES */}
              <h6 className="border-bottom pb-2 mb-3 mt-4">Condiciones Comerciales</h6>
              <Row>
                <Col md={12}>
                  <Card className="border-0 bg-light w-100">
                    <Card.Body className="w-100">
                      <h6 className="text-muted small">Condiciones de Pago</h6>
                      <p className="mb-0">{dataActual.condiciones_pago}</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/*dataActual.terminos_condiciones && (
                <Card className="border-0 bg-light mt-3 w-100">
                  <Card.Body>
                    <h6 className="text-muted small">Términos y Condiciones</h6>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {dataActual.terminos_condiciones}
                    </p>
                  </Card.Body>
                </Card>
              )*/}


              {/* OBSERVACIONES Y ARCHIVOS ADJUNTOS */}
              {dataActual.observaciones && ( 
                <Card className="border-0 bg-light mt-3 w-100">
                  <Card.Body className="w-100">
                    <h6 className="text-muted small">Observaciones</h6>
                    <p className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>
                      {!obsExpanded && dataActual.observaciones.length > OBS_LIMIT
                        ? dataActual.observaciones.substring(0, OBS_LIMIT) + '…'
                        : dataActual.observaciones}
                    </p>
                    {dataActual.observaciones.length > OBS_LIMIT && (
                      <Button
                        variant="link"
                        size="sm"
                        className="p-0 mt-1"
                        onClick={() => setObsExpanded(v => !v)}
                      >
                        {obsExpanded
                          ? 'Ver menos'
                          : `Ver más (${(dataActual.observaciones.length - OBS_LIMIT).toLocaleString('es-CO')} caracteres más)`}
                      </Button>
                    )}
                  </Card.Body>
                </Card>
              )}
              {dataActual.fileDownload.length > 0 && (
                <Card className="border-0 bg-light mt-3 w-100">
                  <Card.Body className="w-100">
                    <h6 className="text-muted small">Archivo adjunto</h6>
                    <a href={dataActual.fileDownload} target="_blank" rel="noopener noreferrer">
                      <i className="bi bi-paperclip me-1"></i>
                      {extraerNombreArchivo(dataActual.fileDownload)}
                    </a>
                  </Card.Body>
                </Card>
              )}

              {/* CAMBIOS SOLICITADOS */}
              {dataActual.estado === 'cambios_solicitados' && solicitudesCambio.length > 0 && (
                <Card className="border-warning mt-4 w-100">
                  <Card.Header className="w-100 bg-warning bg-opacity-25">
                    <h6 className="mb-0"><i className="bi bi-pencil-square me-2"></i>Cambios Solicitados por el Cliente</h6>
                  </Card.Header>
                  <Card.Body className="w-100">
                    <Table size="sm" bordered>
                      <thead className="table-light">
                        <tr>
                          <th>Ítem</th>
                          <th>Tipo de Cambio</th>
                          <th>Cant. Sugerida</th>
                          <th>Comentario</th>
                        </tr>
                      </thead>
                      <tbody>
                        {solicitudesCambio.map((sol, idx) => (
                          <tr key={idx}>
                            <td>{sol.item_nombre || `Ítem ${sol.item_index + 1}`}</td>
                            <td><Badge bg="info">{sol.tipo_cambio}</Badge></td>
                            <td>{sol.cantidad_sugerida || '-'}</td>
                            <td>{sol.comentario_cliente || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex gap-2">
                      <Button
                        variant="primary"
                        onClick={handleProcesarCambios}
                        disabled={procesandoCambios}
                      >
                        {procesandoCambios ? <Spinner size="sm" animation="border" /> : 'Marcar como revisadas'}
                      </Button>
                      <Button
                        variant="outline-primary"
                        onClick={() => navigate(`/propuestas/editar/${id}`)}
                      >
                        <i className="bi bi-pencil me-1"></i>Editar propuesta
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              )}

              {/* SINCRONIZACIÓN CONTABLE */}
              {!propuesta.sincronizada_siigo && syncValidacion && (
                <Card className="mt-4 w-100">
                  <Card.Header className="w-100">
                    <h6 className="mb-0"><i className="bi bi-arrow-repeat me-2"></i>Sincronización Contable</h6>
                  </Card.Header>
                  <Card.Body className="w-100">
                    {syncValidacion.valid ? (
                      <div>
                        <Alert variant="success">Validación exitosa. La propuesta está lista para sincronizar con el software contable.</Alert>
                        <div className="d-flex gap-2">
                          <Button variant="primary" onClick={handleSincronizar} disabled={syncLoading}>
                            {syncLoading ? <Spinner size="sm" animation="border" /> : 'Confirmar sincronización'}
                          </Button>
                          <Button variant="outline-secondary" onClick={() => setSyncValidacion(null)}>Cancelar</Button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Alert variant="warning">
                          <strong><i className="bi bi-exclamation-triangle me-2"></i>No se puede sincronizar:</strong>
                          <ul className="mb-0 mt-2">
                            {syncValidacion.errors?.map((err, i) => <li key={i}>{err}</li>)}
                          </ul>
                        </Alert>
                        <Button variant="outline-secondary" size="sm" onClick={() => setSyncValidacion(null)}>Cerrar</Button>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}

              {propuesta.sincronizada_siigo && (
                <Alert variant="success" className="mt-4">
                  <i className="bi bi-check-circle me-2"></i>
                  <strong>Sincronizada</strong> — Número contable: {propuesta.siigo_numero}
                </Alert>
              )}

              {/* REACTIVAR */}
              {propuesta.estado === 'vencida' && (
                <Card className="mt-4 w-100">
                  <Card.Header className="w-100">
                    <h6 className="mb-0"><i className="bi bi-arrow-clockwise me-2"></i>Reactivar Propuesta</h6>
                  </Card.Header>
                  <Card.Body className="w-100">
                    {!mostrarReactivar ? (
                      <Button variant="warning" onClick={() => setMostrarReactivar(true)}>Reactivar</Button>
                    ) : (
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-2">
                            <Form.Label>Nueva fecha de vigencia</Form.Label>
                            <Form.Control
                              type="date"
                              value={reactivarData.nueva_fecha_vigencia}
                              onChange={(e) => setReactivarData(prev => ({ ...prev, nueva_fecha_vigencia: e.target.value }))}
                              min={moment.utc().format('YYYY-MM-DD')}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-2">
                            <Form.Label>Email destino</Form.Label>
                            <Form.Control
                              type="email"
                              value={reactivarData.email_destino}
                              onChange={(e) => setReactivarData(prev => ({ ...prev, email_destino: e.target.value }))}
                              placeholder="correo@ejemplo.com"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4} className="d-flex align-items-end gap-2 mb-2">
                          <Button variant="primary" onClick={handleReactivar} disabled={reactivarLoading}>
                            {reactivarLoading ? <Spinner size="sm" animation="border" /> : 'Confirmar'}
                          </Button>
                          <Button variant="secondary" onClick={() => setMostrarReactivar(false)}>Cancelar</Button>
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                </Card>
              )}

              {/* TIMELINE */}
              <TimelinePropuesta timeline={dataActual.timeline || []} />

              {/* FOOTER: creado / editado por */}
              <div className="mt-4 pt-3 border-top text-muted small d-flex gap-4">
                {propuesta.creado_por && (
                  <span>
                    <i className="bi bi-person-plus me-1"></i>
                    <strong>Creado por:</strong>{' '}
                    {propuesta.creado_por.nombre} {propuesta.creado_por.apellido}
                  </span>
                )}
                {propuesta.modificado_por && (
                  <span>
                    <i className="bi bi-pencil me-1"></i>
                    <strong>Última edición por:</strong>{' '}
                    {propuesta.modificado_por.nombre} {propuesta.modificado_por.apellido}
                  </span>
                )}
              </div>
            </Tab>

            {/* TAB: VERSIONES */}
            <Tab 
              eventKey="versiones" 
              title={
                <>
                  <i className="bi bi-clock-history me-2"></i>
                  Versiones ({versiones.length})
                </>
              }
            >
              <Alert variant="info">
                <i className="bi bi-info-circle me-2"></i>
                Cada vez que se edita la propuesta, se guarda automáticamente una nueva versión 
                para mantener trazabilidad de todos los cambios.
              </Alert>

              {versiones.length > 0 ? (
                <div className="table-responsive">
                  <Table hover>
                    <thead className="table-light">
                      <tr>
                        <th>Versión</th>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Motivo del Cambio</th>
                        <th>Total</th>
                        <th className="text-center">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {versiones.map((version) => (
                        <tr key={version._id} className={version.numero_version === propuesta.numero_version ? 'table-primary' : ''}>
                          <td>
                            <Badge bg={version.numero_version === propuesta.numero_version ? 'success' : 'secondary'}>
                              v{version.numero_version}
                              {version.numero_version === propuesta.numero_version && ' (Actual)'}
                            </Badge>
                          </td>
                          <td>{moment.utc(version.fecha_propuesta).format('DD/MM/YYYY HH:mm')}</td>
                          <td>
                            {version.creado_por?.nombre + ' ' + version.creado_por?.apellido || 'N/A'}
                          </td>
                          <td>
                            <small>{version.motivo_cambio || 'Sin descripción'}</small>
                          </td>
                          <td className="fw-bold">
                            ${version.total_pagar?.toLocaleString('es-CO')}
                          </td>
                          <td className="text-center">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleVerVersion(version)}
                            >
                              <i className="bi bi-eye me-1"></i>
                              Ver
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <Alert variant="info">
                  No hay versiones anteriores de esta propuesta.
                </Alert>
              )}
            </Tab>

            {/* TAB: ADJUNTOS */}
            <Tab eventKey="adjuntos" title={<><i className="bi bi-paperclip me-2"></i>Adjuntos</>}>
              <div className="mb-3">
                <Form.Label className="fw-bold">Subir archivo adjunto</Form.Label>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="file"
                    accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls,.doc,.docx"
                    disabled={subiendoAdj}
                    style={{ maxWidth: 320 }}
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      setSubiendoAdj(true);
                      try {
                        const res = await subirArchivoPropuesta(propuesta._id, 'adjuntos', file);
                        const url = res.data?.url;
                        if (url) {
                          const upd = await agregarAdjuntoPropuesta(propuesta._id, url);
                          setPropuesta(prev => ({ ...prev, fileAdjuntos: upd.data?.data || [] }));
                        }
                      } catch { /* silencioso */ }
                      setSubiendoAdj(false);
                      e.target.value = '';
                    }}
                  />
                  {subiendoAdj && <Spinner animation="border" size="sm" />}
                </div>
              </div>
              {(!propuesta.fileAdjuntos || propuesta.fileAdjuntos.length === 0) ? (
                <Alert variant="light">Sin archivos adjuntos.</Alert>
              ) : (
                <ul className="list-group">
                  {propuesta.fileAdjuntos.map((url, idx) => {
                    // extraer el nombre de ejemplo propuestas/69e2f58d8447378263fbdeeb/Acta_A-uu4-1.pdf => Acta_A-uu4-1.pdf

                    const nombre = extraerNombreArchivo(url) || `Adjunto ${idx + 1}`;
                    return (
                      <li key={idx} className="list-group-item d-flex align-items-center justify-content-between">
                        <a href={url} target="_blank" rel="noreferrer" className="text-truncate me-2" style={{ maxWidth: '80%' }}>
                          <i className="bi bi-file-earmark me-1"></i>{nombre}
                        </a>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          disabled={subiendoAdj}
                          onClick={async () => {
                            if (!window.confirm('¿Eliminar este adjunto?')) return;
                            setSubiendoAdj(true);
                            try {
                              const upd = await eliminarAdjuntoPropuesta(propuesta._id, url);
                              setPropuesta(prev => ({ ...prev, fileAdjuntos: upd.data?.data || [] }));
                            } catch { /* silencioso */ }
                            setSubiendoAdj(false);
                          }}
                        >
                          <i className="bi bi-trash"></i>
                        </Button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </Tab>

            {/* TAB: LINK APROBACIÓN */}
            {propuesta.token_aprobacion && ['enviada', 'vista', 'aprobada', 'rechazada'].includes(propuesta.estado) && (
              <Tab 
                eventKey="aprobacion" 
                title={<><i className="bi bi-link-45deg me-2"></i>Link de Aprobación</>}
              >
                <Alert variant="success">
                  <h6><i className="bi bi-link-45deg me-2"></i>Link Público para Aprobación del Cliente</h6>
                  <p className="mb-2">
                    Comparta este link con el cliente para que pueda ver y aprobar/rechazar la propuesta:
                  </p>
                  <div className="d-flex gap-2">
                    <Form.Control
                      type="text"
                      value={`${window.location.origin}/propuestas/aprobar/${propuesta.token_aprobacion}`}
                      readOnly
                    />
                    <Button
                      variant="primary"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          `${window.location.origin}/propuestas/aprobar/${propuesta.token_aprobacion}`
                        );
                        alert('Link copiado al portapapeles');
                      }}
                    >
                      <i className="bi bi-clipboard"></i>
                    </Button>
                  </div>
                </Alert>

                {propuesta.estado === 'vista' && (
                  <Alert variant="info">
                    <i className="bi bi-eye me-2"></i>
                    El cliente ya visualizó la propuesta el {moment.utc(propuesta.fecha_vista).format('DD/MM/YYYY HH:mm')}
                  </Alert>
                )}
              </Tab>
            )}
          </Tabs>
        </Card.Body>
      </Card>

      {/* DEBUG: Payload sincronización */}
      {syncValidacion && (
        <div className="mt-3">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
            onClick={() => setShowDebugPayload(p => !p)}
          >
            <i className={`bi bi-chevron-${showDebugPayload ? 'up' : 'down'}`}></i>
            <i className="bi bi-braces ms-1"></i>
            Debug — Payload validación sync
          </button>
          {showDebugPayload && (
            <pre
              style={{
                background: '#1e1e1e',
                color: '#d4d4d4',
                fontSize: '0.78rem',
                padding: '1rem',
                borderRadius: '6px',
                marginTop: '6px',
                maxHeight: '400px',
                overflowY: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all'
              }}
            >
              {JSON.stringify(syncValidacion, null, 2)}
            </pre>
          )}
        </div>
      )}

      {/* MODAL ENVIAR EMAIL */}
      <ModalEnvioEmail
        show={showModalEmail}
        onHide={() => setShowModalEmail(false)}
        onConfirm={handleEnviarPropuesta}
        emailInicial={propuesta.cliente_email || ''}
        loading={enviandoEmail}
      />
    </div>
  );
};

export default DetallePropuesta;